import { Typography } from '@mui/material';

export function MadeInCanada() {
	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '6px',
				marginTop: '40px',
			}}
		>
			<Typography variant="h3">Canadian-built software</Typography>
			<Typography variant="h4" sx={{ alignSelf: 'bottom' }}>
				🇨🇦
			</Typography>
		</div>
	);
}
